import { Box } from "@mui/material"

export const ChevronDown = ({ color, width = 24, height = 24 }) => {
    return (
        <Box
            component="svg"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 23.489 12.245"
            sx={{
                color: color || "#a18168",
            }}
            className="transition-colors"
        >
            <polyline
                points="22.989 .5 11.745 11.745 .5 .5"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
                fill="none"
            />
        </Box>
    )
}